import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7821e740"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "me-1" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dash-circle-fill" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ms-1" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_numeric_fld_input = _resolveComponent("numeric-fld-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn-action",
        type: "button",
        disabled: !_ctx.isSubPossible,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.subOper && _ctx.subOper(...args)))
      }, _hoisted_5, 8, _hoisted_3)
    ]),
    _createVNode(_component_numeric_fld_input, {
      modelValue: _ctx.inputValue.RefundNowQty,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValue.RefundNowQty) = $event)),
      class: "flex-fill",
      onChange: _ctx.changeManualValue
    }, null, 8, ["modelValue", "onChange"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "btn-action",
        type: "button",
        disabled: !_ctx.isAddPossible,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addOper && _ctx.addOper(...args)))
      }, _hoisted_9, 8, _hoisted_7)
    ])
  ]))
}